module.exports = __webpack_public_path__ + "img/video_v2-01.7d147350.png";